import { render, staticRenderFns } from "./DetailSaleProforma.vue?vue&type=template&id=9c94305c"
import script from "./DetailSaleProforma.vue?vue&type=script&lang=js"
export * from "./DetailSaleProforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports